if (!customElements.get('proof-slider')) {
  class ProofSlider extends HTMLElement {
    constructor() {
      super();
      this.sliderList = this.querySelector('.proof-slider__list');

      this.left = this.querySelector('.proof-slider__left');
      this.right = this.querySelector('.proof-slider__right');
      this.navigation = this.querySelector('.proof-slider__navigation');

      this.slide = this.sliderList.children[0];
      this.currentIndex;

      this.left.addEventListener('click', () => {
        this.sliderList.scrollLeft += this.slide.clientWidth;
      });


      this.right.addEventListener('click', () => {
        this.sliderList.scrollLeft -= this.slide.clientWidth;
      });

      this.setupEvents();

      this.sliderList.addEventListener('scroll', () => {
        this.visibilityNavigation();
      })
    }

    setupEvents() {
      const sliderScrollObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              this.currentIndex = parseInt(entry.target.dataset.index);
              this.visibilityNavigation();
            }
          });
        },
        {
          threshold: 0.7,
        }
      );

      [...this.sliderList.children].forEach((slide) => {
        sliderScrollObserver.observe(slide);
      });
    }

    visibilityNavigation() {
      const size = this.sliderList.children.length - 1;
      const firstSlidePosition = this.slide.getBoundingClientRect().x;
      const sliderListPosition = this.sliderList.getBoundingClientRect().x
      firstSlidePosition > sliderListPosition
        ? (this.right.setAttribute('data-active', 'false'))
        : (this.right.setAttribute('data-active', 'true'));

      this.currentIndex === size
        ? (this.left.setAttribute('data-active', 'false'))
        : (this.left.setAttribute('data-active', 'true'));

      // Set parent navigation data-active based on left and right states
      const leftActive = this.left.getAttribute('data-active') === 'true';
      const rightActive = this.right.getAttribute('data-active') === 'true';

      if (!leftActive && !rightActive) {
        this.navigation.setAttribute('data-active', 'false');
      } else {
        this.navigation.setAttribute('data-active', 'true');
      }
    }
  }

  customElements.define('proof-slider', ProofSlider);
}
